import { useState } from 'react';
import { categories } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function CategoryRail() {
  const [active, setActive] = useState('c1');

  return (
    <section id="category" className="scroll-mt-24 bg-background-100 py-10 md:py-14 border-y border-background-200">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="GENRE INDEX"
          title="题材速览 · 按心情挑片"
          desc="八大题材一路排开，点一下就能切换你此刻想看的那种青春。"
          actionLabel="查看完整分类"
          actionHref="#library"
        />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => {
            const isActive = active === cat.id;
            return (
              <button
                key={cat.id}
                type="button"
                onClick={() => setActive(cat.id)}
                className={`group relative text-left rounded-lg overflow-hidden border transition-all ${
                  isActive
                    ? 'border-primary-500 ring-2 ring-primary-300/60'
                    : 'border-background-200 hover:border-primary-300'
                }`}
              >
                <div className="relative w-full h-28 md:h-32">
                  <img
                    src={cat.image}
                    alt={`${cat.name} 青春电影分类`}
                    title={`${cat.name} - 青苹果影院青春电影分类`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 via-foreground-950/20 to-transparent" />
                  {isActive && (
                    <span className="absolute top-2.5 right-2.5 w-6 h-6 rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
                      <i className="ri-check-line text-sm" />
                    </span>
                  )}
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <div className="text-background-50 font-bold text-base">{cat.name}</div>
                    <div className="text-background-200 text-xs mt-0.5">{cat.count.toLocaleString()} 部在库</div>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}